import TagSelect from './TagSelect'

export default TagSelect
